export const navList = [
  { index: 1, linkName: "Profile", linkTo: "/#about-section" },
  { index: 2, linkName: "Portfolio", linkTo: "/#projects-section" },
  { index: 3, linkName: "Contact", linkTo: "/#contact-section" },
];
